// v2/constants/adminNav.js — yonetim paneli menusu
// ready: true olmayan ogeler menude "Yakinda" olarak pasif gorunur.
// Sayfa yazildikca ready: true yapilir.

export const ADMIN_HOME = '/v2/admin';

export const ADMIN_NAV = [
  {
    group: 'Genel',
    items: [
      { id: 'overview', label: 'Genel Bakış', short: 'Özet', icon: 'LayoutDashboard', to: '/v2/admin', end: true, ready: true },
    ],
  },
  {
    group: 'Satış',
    items: [
      { id: 'customers', label: 'Müşteriler', short: 'Müşteri', icon: 'Store', to: '/v2/admin/customers', ready: true },
      { id: 'orders', label: 'Siparişler', short: 'Sipariş', icon: 'ShoppingBag', to: '/v2/admin/orders', ready: true },
      { id: 'quotes', label: 'Teklifler', short: 'Teklif', icon: 'FileText', to: '/v2/admin/quotes', ready: true },
      { id: 'debt', label: 'Borç Yaşlandırma', short: 'Borç', icon: 'Wallet', to: '/v2/admin/debt', ready: true },
    ],
  },
  {
    group: 'Kullanıcılar',
    items: [
      { id: 'users', label: 'Kullanıcılar', short: 'Kullanıcı', icon: 'UserCog', to: '/v2/admin/users', ready: true },
      { id: 'logins', label: 'Giriş Kayıtları', short: 'Girişler', icon: 'LogIn', to: '/v2/admin/logins', ready: true },
    ],
  },
  {
    group: 'Pazarlama',
    items: [
      { id: 'campaigns', label: 'Kampanyalar', short: 'Kampanya', icon: 'Percent', to: '/v2/admin/campaigns', ready: true },
      { id: 'announcements', label: 'Duyurular', short: 'Duyuru', icon: 'Megaphone', to: '/v2/admin/announcements', ready: true },
    ],
  },
];

// Mobil alt cubuk (sona otomatik "Menü" eklenir)
export const ADMIN_BOTTOM_NAV = ['overview', 'customers', 'orders', 'users'];
